function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "View-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9aa5b1"
    },
    d: "m 12.14,12.245395 a 5.77,5.77 0 0 1 -8.29,0 v 0 L 0.22,8.5253948 a 0.76,0.76 0 0 1 0,-1.06 v 0 l 3.63,-3.71 a 5.78,5.78 0 0 1 8.3,0 v 0 l 3.63,3.71 a 0.76,0.76 0 0 1 0,1.06 v 0 l -3.63,3.7100002 z m -4.14,-0.5 a 3.7,3.7 0 0 0 3.66,-3.7400002 3.71,3.71 0 0 0 -3.66,-3.75 3.72,3.72 0 0 0 -3.68,3.75 A 3.71,3.71 0 0 0 8,11.745395 Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#9aa5b1"
    },
    ry: 2.25,
    rx: 2.2,
    cy: 7.9953947,
    cx: 8.0699997
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeGrey);
export default __webpack_public_path__ + "static/media/eye_grey.8db1c5f574dc7202975b799ba032acf1.svg";
export { ForwardRef as ReactComponent };